module.exports = __webpack_public_path__ + "static/media/shape-1.e7c6d73f.png";